import { MEDIA_QUERY } from "@farzoom/common-ui-components";
import { borderRadius, borderRadiusHalf, colors, ellipsis, fonts, locked } from "./theme";

export const carrotColors = {
  main: "#F36223",
  inputBg: "#F0F2F5",
  primary: "#242729",
  blue800: "#3557A6",
  green100: "#F4FBF7",
  green400: "#D8F8E7",
  green600: "#75CC9E",
  green800: "#1D7C4D",
  orange100: "#FEE9D8",
  orange200: "#fbe1cc",
  orange400: "#FA9368",
  orange600: "#F84C23",
  orange800: "#CE2C0B",
  yellow100: "#FFF2CC",
  yellow400: "#FFE499",
  yellow600: "#FFBE08",
  yellow800: "#CA9500",
  grey100: "#F7F7F7",
  grey400: "#E2E2E2",
  grey800: "#8E909B",
  grey1100: "#2D2D2D",
};

const cssVariables = {
  "--ant-primary-color": carrotColors.main,
};

export const carrot = {
  "&.carrot": {
    ...cssVariables,

    "& .modal": {
      "& .ant-typography h5, div.ant-typography-h5, div.ant-typography-h5 > textarea, h5.ant-typography":
        {
          color: colors.coal1,
          fontSize: 16,
          minHeight: 24,
          fontFamily: fonts.roboto,
          fontWeight: 500,
          lineHeight: 24 / 16,
          textTransform: "uppercase",
        },
      "& .ant-picker-input > input, .ant-input-search .ant-input-lg": {
        lineHeight: 24 / 16,
      },
      "& .ant-input-lg, .ant-picker-large, .ant-input-number-lg .ant-input-number-input, .ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input":
        {
          background: colors.gray,
          width: "100%",
          height: 56,
          padding: 16,
          color: colors.coal1,
          fontSize: 16,
          lineHeight: 24 / 16,
          fontWeight: 400,
          border: [1, "solid", colors.gray],
          borderRadius,
          fontFamily: fonts.roboto,
          outline: "none",
          cursor: "text",
          boxSizing: "border-box",
          ...ellipsis,
          "&.ant-picker-status-error": {
            borderColor: colors.error,
          },
          [MEDIA_QUERY.mobile]: {
            height: 40,
            padding: 8,
            fontSize: 14,
            lineHeight: 1.2,
            borderRadius: borderRadiusHalf,
          },
        },
      "& textarea.ant-input-lg": {
        whiteSpace: "normal",
      },
      "& span.ant-input-group-wrapper > span.ant-input-wrapper > span:first-child, span.ant-input-group-wrapper > span.ant-input-wrapper > input.ant-input:first-child":
        {
          borderRadius: [borderRadius, 0, 0, borderRadius],
        },
      "& .ant-select:not(.ant-select-customize-input) .ant-select-selector": {
        background: "none",
        minHeight: 56,
        padding: 0,
        border: "none",
        [MEDIA_QUERY.mobile]: {
          minHeight: 40,
        },
      },
      "& .ant-select-single.ant-select-show-arrow .ant-select-selection-search": {
        right: 0,
        left: 0,
      },
      "& .ant-select-single.ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder":
        {
          background: colors.gray,
          width: "100%",
          height: 56,
          padding: 16,
          color: colors.coal1,
          fontSize: 16,
          lineHeight: 24 / 16,
          fontWeight: 500,
          border: [1, "solid", colors.borderColor],
          borderRadius,
          [MEDIA_QUERY.mobile]: {
            height: 40,
            padding: 8,
            fontSize: 14,
            lineHeight: 1.2,
            borderRadius: borderRadiusHalf,
          },
        },
      "& .ant-select-selection-overflow": {
        background: colors.gray,
        width: "100%",
        minHeight: 56,
        padding: 16,
        border: [1, "solid", colors.gray],
        borderRadius,
      },
      "& .ant-select-multiple.ant-select-lg .ant-select-selection-search": {
        height: 22 / 14,
        lineHeight: 22 / 14,
        "& .ant-select-selection-search-input": {
          padding: 0,
          height: 22 / 14,
          lineHeight: 22 / 14,
        },
      },
      "& .ant-select-multiple .ant-select-selection-item": {
        height: "auto",
        padding: 8,
        color: colors.coal1,
        fontSize: 14,
        lineHeight: 22 / 14,
        fontWeight: 500,
        borderRadius,
        border: [1, "solid", colors.coal4],
        fontFamily: fonts.roboto,
      },
      "& .ant-select-multiple .ant-select-selection-item-remove svg": {
        width: 16,
        height: 16,
      },
      "& .ant-select-dropdown": {
        border: "none",
        borderRadius: [[borderRadius], "!important"],
      },
      "& .ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input) .ant-select-selection-search-input":
        {
          height: 56,
          padding: 16,
          boxSizing: "border-box",
        },
      "& .ant-select, .ant-input-number-input, .ant-picker-input > input, .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item, .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder, .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector:after":
        {
          color: colors.coal1,
          fontSize: 16,
          lineHeight: 24 / 16,
          fontWeight: 400,
          fontFamily: fonts.roboto,
        },
      "& .ant-select-item": {
        width: "100%",
        height: 56,
        padding: 16,
        color: colors.coal1,
        fontSize: 16,
        lineHeight: 24 / 16,
        fontWeight: 400,
        fontFamily: fonts.roboto,
        ...ellipsis,
      },
      "& .ant-select-item-empty": {
        // background: colors.gray,
        width: "100%",
        padding: 16,
        color: colors.coal1,
        fontSize: 16,
        lineHeight: 24 / 16,
        fontWeight: 500,
        fontFamily: fonts.roboto,
        ...ellipsis,
      },
      "& .ant-select-multiple .ant-select-selection-item-content": {
        whiteSpace: "normal",
      },
      "& .ant-input-number:not([class*=status-error])": {
        borderColor: "transparent",
      },
      "& .ant-select-item-option": {
        height: "auto",
        padding: [8, 16],
      },
      "& .ant-select-item-option-active:not(.ant-select-item-option-disabled)": {
        background: colors.disabled,
      },
      "& .ant-input-lg:hover, .ant-picker-large:hover, .ant-btn:hover, .ant-input-search .ant-input:hover, .ant-input-search .ant-input:hover + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary)":
        {
          borderColor: colors.gray,
        },
      "& .ant-input-lg:focus, .ant-picker-large:focus, .ant-input-lg:active, .ant-picker-large:active, .ant-btn:focus, .ant-input-search .ant-input:focus, .ant-input-search .ant-input:focus + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary), .ant-picker-focused, .ant-picker-focused:hover, .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector, .ant-input-number-focused, .ant-input-number:focus, .ant-input-number-focused:not([class*=status-error]) .ant-input-number-input":
        {
          borderColor: colors.borderHoverColor,
          boxShadow: "none",
          outline: "none",
        },
      "& .ant-input-lg:disabled, .ant-picker.ant-picker-disabled, .ant-select-single.ant-select-show-arrow.ant-select-disabled .ant-select-selection-item, .ant-select-single.ant-select-show-arrow.ant-select-disabled .ant-select-selection-placeholder, .ant-input-number.ant-input-number-disabled .ant-input-number-input":
        {
          backgroundColor: colors.disabled,
          paddingRight: 40,
          borderColor: colors.disabled,
          cursor: "default",
          ...locked,
          "&:hover": {
            borderColor: colors.disabled,
          },
        },
      "& .ant-input[disabled], .ant-picker-input > input[disabled]": {
        cursor: "default",
      },
      "& .ant-select-single.ant-select-show-arrow.ant-select-disabled .ant-select-arrow": {
        right: 40,
      },
      "& .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover":
        {
          background: colors.gray,
        },
      "& .ant-form-item-has-error .ant-input, .ant-input-group-wrapper-status-error .ant-btn.ant-input-search-button, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover, .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selection-search-input, .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selection-placeholder":
        {
          background: colors.gray,
          borderColor: colors.error,
        },
      "& .ant-select-arrow": {
        width: 24,
        height: 24,
        marginTop: -12,
      },
      "& .ant-select-suffix": {
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 9L12 15L18 9' stroke='%23949BA0' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")",
        backgroundPosition: "center center",
        width: "inherit",
        height: "inherit",
        padding: 0,
        "& svg": {
          display: "none",
        },
      },
      "& .ant-picker.ant-picker-disabled .ant-picker-suffix": {
        display: "none",
      },
      "& .ant-form-item-label": {
        width: "100%",
        whiteSpace: "normal",
        "& > label": {
          height: "auto",
          marginBottom: 8,
          color: colors.coal4,
          fontFamily: fonts.roboto,
          fontSize: 14,
          lineHeight: 1.2,
          fontWeight: 400,
          textAlign: "left",
          display: "block",
          [MEDIA_QUERY.mobile]: {
            fontSize: 12,
          },
        },
      },
      "& .ant-col-24.ant-form-item-label, .ant-col-xl-24.ant-form-item-label, .ant-form-vertical .ant-form-item-label":
        {
          padding: 0,
        },
      "& .ant-btn": {
        background: colors.primaryColor,
        height: 56,
        padding: [11, 32],
        color: colors.white,
        fontSize: 16,
        lineHeight: 24 / 16,
        borderRadius,
        border: [1, "solid", colors.primaryColor],
        [MEDIA_QUERY.mobile]: {
          height: 40,
          padding: [8, 16],
          borderRadius: borderRadiusHalf,
          lineHeight: 1,
        },
        "&:hover": {
          borderColor: colors.coal1,
        },
        "&.ant-btn-default": {
          background: colors.white,
          color: colors.coal1,
          borderColor: colors.coal1,
        },
        "&.ant-btn-primary": {
          background: colors.primaryColor,
          color: colors.white,
          border: [1, "solid", colors.primaryColor],
          "&:not([disabled]):hover": {
            borderColor: colors.primaryColor,
          },
        },
        "&.ant-btn-dangerous": {
          background: colors.white,
          color: colors.primaryColor,
          borderColor: colors.primaryColor,
        },
        "&.ant-btn-icon-only": {
          width: 32,
          height: 32,
          padding: [2.4, 0],
        },
        "&.ant-input-search-button": {
          background: colors.gray,
          height: 56,
          borderColor: colors.gray,
        },
        "&[disabled]": {
          color: "rgba(0, 0, 0, 0.25)",
          borderColor: "#d9d9d9",
          background: "#f5f5f5",
          "&:hover": {
            borderColor: "#d9d9d9",
          },
        },
      },
      "& .ant-input-disabled + .ant-input-group-addon > .ant-input-search-button": {
        background: colors.disabled,
      },
      "& .ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button":
        {
          borderRadius: [0, borderRadius, borderRadius, 0],
        },
      "& .ant-tabs-tab": {
        color: colors.coal4,
        padding: 8,
        fontSize: 16,
        fontWeight: 500,
        lineHeight: 1.2,
        fontFamily: fonts.roboto,
        [MEDIA_QUERY.mobile]: {
          fontSize: 14,
        },
        "& + .ant-tabs-tab": {
          margin: [0, 0, 0, 16],
        },
      },
      "& .ant-select-item-option-selected:not(.ant-select-item-option-disabled)": {
        background: colors.white,
        fontWeight: 600,
        "&:hover": {
          background: colors.disabled,
        },
      },
    },
    "& button": {
      [MEDIA_QUERY.mobile]: {
        height: 40,
        padding: [8, 16],
      },
      "&.withIcon": {
        [MEDIA_QUERY.mobile]: {
          height: "auto",
          padding: 8,
          aspectRatio: 1,
        },
      },
    },
    "& .ant-tag": {
      borderRadius: 6,
      lineHeight: 1.5715,
    },
    "& [class*=ant-input], & .ant-picker, & .ant-select-selector": {
      borderRadius: borderRadiusHalf,
    },
    "& [class*=ant-input] > input": {
      borderRadius: 0,
    },
    "& .ant-select-dropdown": {
      borderRadius: borderRadiusHalf,
    },
  },
};
